function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 19.7597C19.5 18.9313 18.8284 18.2597 18 18.2597H13C12.1716 18.2597 11.5 18.9313 11.5 19.7597C11.5 20.5881 12.1716 21.2597 13 21.2597H18C18.8284 21.2597 19.5 20.5881 19.5 19.7597Z",
  fill: "#306BF6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.6704 8C23.6704 4.96243 21.208 2.5 18.1704 2.5H12.8296C9.792 2.5 7.32957 4.96244 7.32957 8V11.9945C5.97214 12.476 5 13.7715 5 15.294V24C5 25.933 6.56701 27.5 8.5 27.5H22.5C24.433 27.5 26 25.933 26 24V15.294C26 13.361 24.433 11.794 22.5 11.794H10.3296V8C10.3296 6.61929 11.4489 5.5 12.8296 5.5H18.1704C19.5511 5.5 20.6704 6.61929 20.6704 8V9.00894C20.6704 9.83737 21.342 10.5089 22.1704 10.5089C22.9989 10.5089 23.6704 9.83737 23.6704 9.00894V8ZM22.5 14.794C22.7761 14.794 23 15.0179 23 15.294V24C23 24.2761 22.7761 24.5 22.5 24.5H8.5C8.22386 24.5 8 24.2761 8 24V15.294C8 15.0179 8.22386 14.794 8.5 14.794H22.5Z",
  fill: "#306BF6"
});

function SvgCredentials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentials);
export default __webpack_public_path__ + "static/media/credentials.b5d94367.svg";
export { ForwardRef as ReactComponent };